import React from "react";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import g from "glamorous";
import Layout from "../../components/layout";
import Img from "gatsby-image";
import Menu from "../../components/Menu-en";
import Footer from "../../components/Footer-en";
import AdresseSidebar from "../../components/AdresseSidebar-en";
import ContactSidebar from "../../components/ContactSidebar-en";
import Accordion from "../../components/Accordion-en";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";
import { FaPlus } from "react-icons/fa";

export default function errorPage({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { lvpa, protheses, keybodySkin, hydrafacial, keybodyLipo, rhino } = data;

  const Wrapper = g.main({
    maxWidth: `1200px`,
    margin: `3em auto 2.5em`,
    "@media(max-width: 767px)": {
      margin: `1em auto 2.5em`,
    },
  });

  const H1 = g.h1({
    margin: `.8em 0 20px`,
    color: `#3c4d68`,
    fontSize: `1.7em`,
    fontWeight: `500`,
    lineHeight: `1.25em`,
    letterSpacing: `0.028em`,
    "@media(max-width: 767px)": {
      fontSize: `1.3em`,
      margin: `0 0 .1em`,
    },
  });

  const H2 = g.h2({
    position: `relative`,
    fontSize: `32px`,
    fontWeight: `500`,
    marginTop: `0.2em`,
    marginBottom: `.5em`,
    "&::after": {
      content: ` `,
      position: `absolute`,
      top: `54%`,
      left: `205px`,
      border: `.063em solid #3c4d68`,
      display: `inline-block`,
      width: `610px`,
    },
    "@media(max-width: 767px)": {
      margin: `.5em 0 .5em`,
      "&::after": {
        content: `none`,
      },
    },
    "@media(max-width: 1100px)": {
      "&::after": {
        content: `none`,
      },
    },
  });

  const Card = g.div({
    backgroundColor: `white`,
    marginTop: `0`,
    marginBottom: `2em`,
    borderRadius: `6px`,
    border: `1px solid rgba(73,105,126,0.08)`,
    boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
    transition: `all 0.15s ease-in-out`,
    ":hover": {
      border: `1px solid rgba(73,105,126,0.18)`,
      boxShadow: `0 1px 10px rgba(0,0,0,.26)`,
      transition: `all 0.15s ease-in-out`,
      transform: `translateY(-2px)`,
    },
    "@media(max-width: 767px)": {
      marginBottom: `1.5em`,
    },
  });

  const Title = g.h3({
    padding: `0 .5em 0 .82em`,
    margin: `.7em 0 .3em`,
    font: `700 18px/1.35em -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
  });

  const Text = g.p({
    padding: `0 .5em 0 .8em`,
    marginBottom: `.6em`,
    color: `#1f1f1f`,
  });

  const PlusWrapper = g.div({
    display: `flex`,
    justifyContent: `flex-end`,
    color: `#3c4d68`,
    margin: `0 1.5em .85em`,
    fontSize: `.8em`,
  });

  return (
    <Layout>
      <g.Div margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <title>Page not available | Plastic Surgeon in Paris 17</title>
          <meta
            name="description"
            content=" Sorry, the requested page is not available (error 404)."
          />
          <html lang="en" />
          <link
            rel="alternate"
            hreflang="fr"
            href="https://www.dr-kron.com/404/"
          />
        </Helmet>
        <Menu pathFr="/" />
        <Wrapper>
          <Container
            css={{
              paddingRight: `12px !important`,
              paddingLeft: `12px !important`,
            }}
          >
            <Row>
              <Col>
                <p className="intro" css={{ marginBottom: `2em` }}>
                  <H1>Page not available</H1>
                  Sorry, the requested page is not available (error 404).
                </p>
              </Col>
            </Row>

            <Row>
              <Col
                span={{ sm: 12 / 12, lg: 74 / 100 }}
                css={{ backgroundcolor: `white` }}
              >
                <section>
                  <H2>Treatments</H2>
                  <Row>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      {" "}
                      <Card>
                        <Link to="/en/face/facelift-lvpa/">
                          <Img
                            fluid={lvpa.childImageSharp.fluid}
                            alt="Facelift LVPA, plastic surgery of the face"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>LVPA Facelift</Title>
                        </Link>
                        <Text>
                          The LVPA facelift can correct face wrinkles naturally
                          and durably, with invisible scars and social life
                          disruption of only one week.
                        </Text>
                        <Link
                          to="/en/face/facelift-lvpa/"
                          title="Informations about facelift LVPA"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>

                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/breast/breast-implants/">
                          <Img
                            fluid={protheses.childImageSharp.fluid}
                            alt="Breast implants"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Breast implants</Title>
                        </Link>
                        <Text>
                          A breast augmentation should embellish breast shape
                          and size while offering a natural result, consistent
                          with the patient's needs.
                        </Text>
                        <Link
                          to="/en/breast/breast-implants/"
                          title="Information about breast implants"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>

                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/skin/keybody-skin/">
                          <Img
                            fluid={keybodySkin.childImageSharp.fluid}
                            alt="Regénérer sa peau en profondeur avec le protocole de médecine esthétique Keybody-Skin"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Keybody-Skin</Title>
                        </Link>
                        <Text>
                          An in-depth regeneration protocol based on the latest
                          innovation in aesthetic medicine: fractional
                          radiofrequency, microneedling, photonic light.
                        </Text>
                        <Link
                          to="/en/skin/keybody-skin/"
                          title="Information about Keybody Skin"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/face/hydrafacial/">
                          <Img
                            fluid={hydrafacial.childImageSharp.fluid}
                            alt="HydraFacial treatments in Paris"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>HydraFacial</Title>
                        </Link>
                        <Text>
                        HydraFacial is a unique treatment that cleanses, extracts, and hydrates your skin in one painless procedure with significant and immediate results.
                        </Text>
                        <Link
                          to="/en/face/hydrafacial/"
                          title="HydraFacial treatments in Paris"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/body-contouring/keybody-lipo/">
                          <Img
                            fluid={keybodyLipo.childImageSharp.fluid}
                            alt="Keybody-Lipo, une technique de suppression définitive des graisses en excès"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Keybody-Lipo</Title>
                        </Link>
                        <Text>
                          Keybody-Lipo is an innovative and non-invasive
                          protocol for permanent fat removal and muscle
                          sculpting of the body. Keybody-Lipo is nonsurgical
                          alternative to a "liposuction".
                        </Text>
                        <Link
                          to="/en/body-contouring/keybody-lipo/"
                          title="Information about Keybody-Lipo"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col span={{ sm: 12 / 12, md: 1 / 2 }}>
                      <Card>
                        <Link to="/en/nose/rhinoplasty/">
                          <Img
                            fluid={rhino.childImageSharp.fluid}
                            alt="Rhinoplasty, plastic surgery of the nose"
                            css={{
                              marginBottom: `.5em`,
                              borderRadius: `6px 6px 0 0`,
                            }}
                          />
                          <Title>Rhinoplasty</Title>
                        </Link>
                        <Text>
                          A rhinoplasty is a surgery of the nose that changes
                          the shape of the nose and provides a more balanced
                          face while maintaining its natural appearance.
                        </Text>
                        <Link
                          to="/en/nose/rhinoplasty/"
                          title="Information about rhinoplasty in Paris"
                        >
                          <PlusWrapper>
                            <FaPlus
                              css={{
                                fontSize: `1em`,
                                padding: `0.45em .3em 0em`,
                              }}
                            />
                            Learn more
                          </PlusWrapper>
                        </Link>
                      </Card>
                    </Col>
                    <Col>
                      <PlusWrapper
                        css={{
                          fontSize: `1.6em`,
                          margin: `0 0 1.4em 0`,
                          "@media(max-width: 767px)": {
                            fontSize: `1.35em`,
                            marginTop: `-0.3em`,
                          },
                        }}
                      >
                        <Link
                          to="/en/treatments/"
                          css={{ textureDecoration: `none`, color: `#3c4d68` }}
                        >
                          <FaPlus
                            css={{
                              fontSize: `1em`,
                              padding: `0.1em .35em 0em`,
                            }}
                          />
                          See all treatments
                        </Link>
                      </PlusWrapper>
                    </Col>
                  </Row>
                </section>
              </Col>

              <Col span={{ sm: 12 / 12, lg: 26 / 100 }}>
                <aside>
                  <Accordion />
                  <ContactSidebar about="the treatments performed by Dr. Cédric Kron" />
                  <AdresseSidebar />
                </aside>
              </Col>
            </Row>
          </Container>
        </Wrapper>
        <Footer />
      </g.Div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query errorPageQueryEn {
    lvpa: file(relativePath: { eq: "images/lifting-visage-lvpa.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    protheses: file(
      relativePath: { eq: "images/augmentation-mammaire-protheses.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    keybodySkin: file(relativePath: { eq: "images/keybody-skin.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    hydrafacial: file(
      relativePath: { eq: "images/hydrafacial-a-paris.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 388) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    keybodyLipo: file(
      relativePath: { eq: "images/keybody-lipo-supprimer-graisses.jpg" }
    ) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    rhino: file(relativePath: { eq: "images/rhinoplastie.jpg" }) {
      childImageSharp {
        resize(width: 1500, height: 1500) {
          src
        }
        fluid(maxWidth: 400) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;
